module.exports = __webpack_public_path__ + "img/topbgrenyuan.91ea5dc8.jpg";